import { ViewCountKeyEnum } from '@ztechapps/common.contract'
import { useViewCount, type UseViewCountResult } from '@ztechapps/common.hook'

/**
 * Hook for managing PurchaseOrder view counts.
 * Automatically increments the view count when the purchase order is viewed.
 *
 * @param purchaseOrderId - The ID of the purchase order
 * @returns viewCount, increment, loading, error
 *
 * @example
 * const { viewCount } = usePurchaseOrderViewCount(purchaseOrderId)
 */
export function usePurchaseOrderViewCount(purchaseOrderId: string): UseViewCountResult {
  return useViewCount({
    key: ViewCountKeyEnum.PurchaseOrder,
    value: purchaseOrderId,
  })
}
